import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutomationInterface, Context, EntityType } from '@vendasta/automata';

export interface DialogOptions {
  hideSettingsLink?: boolean;
  onlySalespersonAutomations?: boolean;
  onlySelectDontStart?: boolean;
  isListOfEntities?: boolean; // used for lists so that separate endpoint can be used (uses row id)
}

export interface StartManualAutomationDialogData {
  companyName: string;
  namespace: string;
  options?: DialogOptions;
  warnings?: string[];
  entities?: Map<EntityType, string[]>; // Entity type to a list of entity ids
  // if you're not starting an automation use entity type to list automations of that type
  entityType: EntityType;
  context: Context;
}

@Component({
  selector: 'automata-start-manual-automation-dialog',
  templateUrl: './start-manual-automation-dialog.component.html',
  styleUrls: ['./start-manual-automation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StartManualAutomationDialogComponent implements OnInit {
  companyName: string;
  hideSettingsLink: boolean;
  onlySalespersonAutomations: boolean;
  onlySelectDontStart: boolean;
  isListOfEntities: boolean;
  namespace: string;
  warnings: string[] = [];
  entityType: EntityType;
  entities: Map<EntityType, string[]>;
  context: Context;

  constructor(
    public dialogRef: MatDialogRef<StartManualAutomationDialogComponent, AutomationInterface>,
    @Inject(MAT_DIALOG_DATA) public data: StartManualAutomationDialogData,
  ) {}

  ngOnInit(): void {
    this.companyName = this.data?.companyName;
    this.hideSettingsLink = this.data?.options?.hideSettingsLink;
    this.onlySalespersonAutomations = this.data?.options?.onlySalespersonAutomations;
    this.namespace = this.data?.namespace;
    this.warnings = this.data?.warnings;
    this.entityType = this.data?.entityType;
    this.onlySelectDontStart = this.data?.options?.onlySelectDontStart;
    this.entities = this.data?.entities;
    this.context = this.data?.context;
    this.isListOfEntities = this.data?.options?.isListOfEntities;
  }

  close(selectedAutomation?: AutomationInterface): void {
    if (selectedAutomation) {
      this.dialogRef.close(selectedAutomation);
    } else {
      this.dialogRef.close();
    }
  }
}
